/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthcareServiceSearchResultModel } from '../../models/healthcare-service-search-result-model';

export interface AdminFhirIdHealthcareServiceGet$Params {
  fhirId: string;
}

export function adminFhirIdHealthcareServiceGet(http: HttpClient, rootUrl: string, params: AdminFhirIdHealthcareServiceGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<HealthcareServiceSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdHealthcareServiceGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<HealthcareServiceSearchResultModel>>;
    })
  );
}

adminFhirIdHealthcareServiceGet.PATH = '/Admin/{fhirId}/HealthcareService';
